// eslint-disable-next-line import/no-named-as-default-member,import/no-named-as-default
import COMMON_ENV from '@/config/env';

let nums = 0;
let initPageBurry = true;
/* eslint-disable */

/** 页面与按钮自动埋点
 *支持dom元素配置以下属性：
 *bp-describe  自定义点击描述  属性配置示例：<img src='xxx' bp-describe='我的发票banner点击'></img>
 */

let buryingPointForButton = (function () {
//	var dxhy_cnzz_id="1279082367"; //线上的：
  let dxhy_cnzz_id = COMMON_ENV.youMengId; // 开发、测试、预发的友盟id
  //	var dxhy_baidu_id="23ec6fd51906cd5b96dbf354aa4a5e66"; //线上的
  let dxhy_baidu_id = COMMON_ENV.baiDuId; // 开发、测试、预发的百度id

  initBuryingPoint();

  // 初始化按钮点击
  window.addEventListener('click', (e) => {
    let i = e.target;
    if (!i) {
      return;
    }
    let burryString = getBurryArrayString(getBurryArray(i));
    if (burryString.length > 0) {
      buryingPointForButton(burryString, '-', '', '1');
    }
  });

  function getBurryArrayString(arr) {
    let tmp = '';
    for (let i in arr) {
      tmp += `${arr[i]}-`;
    }
    return tmp == '-' ? '' : tmp;
  }

  function getBurryArray(target) {
    let arr = new Array();
    let category = target.getAttribute('bp-describe');
    // var action = target.getAttribute("bp-action");
    // var label = target.getAttribute("bp-label");

    let id = target.getAttribute('id');
    id = id || '';
    let name = target.getAttribute('name');
    name = name || '';

    let class_ = target.getAttribute('class');
    class_ = class_ || '';
    let domTag = target.tagName;
    domTag = domTag || '';

    let content = target.innerHTML;
    content = content.length > 40 ? (`${content.substring(0, 40)}...`) : content;
    let relativePath = getUrlRelativePath()

    pushEle(arr, category, 'describe')
    // pushEle(arr,action,'action')
    // pushEle(arr,label,'label')
    pushEle(arr, document.title, 'title')
    pushEle(arr, relativePath, 'path')
    pushEle(arr, id, 'id')
    pushEle(arr, name, 'name')
    pushEle(arr, class_, 'class')
    pushEle(arr, domTag, 'domTag')
    pushEle(arr, content, 'content')

    return arr;
  }

  function pushEle(arr, ele, eleName) {
    if (ele && ele != '-' && ele != 'null' && ele.length < 300) {
      arr.push(`${eleName}:${ele}`);
    }
    return arr;
  }

  function getUrlRelativePath() {
    let url = document.location.toString();
    let arrUrl = url.split('//');
    let start = arrUrl[1].indexOf('/');
    let relUrl = arrUrl[1].substring(start);
    if (relUrl.indexOf('?') != -1) {
      relUrl = relUrl.split('?')[0];
    }
    return relUrl;
  }

  // 友盟埋点
  function burryPointCnzz() {
    let cnzzSpan = document.getElementById(`cnzz_stat_icon_${dxhy_cnzz_id}`);
    if (cnzzSpan != null) {
      return false;
    }
    let cnzz_span = document.createElement('span');

    cnzz_span.id = `cnzz_stat_icon_${dxhy_cnzz_id}`;
    cnzz_span.style.cssText = 'display:none';
    document.getElementsByTagName('html')[0].appendChild(cnzz_span);
    let cnzz_s_tag = document.createElement('script');
    cnzz_s_tag.type = 'text/javascript';
    cnzz_s_tag.async = true;
    cnzz_s_tag.charset = 'utf-8';
    cnzz_s_tag.src = `https://w.cnzz.com/c.php?id=${dxhy_cnzz_id}&async=1`;
    let cnzz_root_s = document.getElementsByTagName('script')[0];
    cnzz_root_s.parentNode.insertBefore(cnzz_s_tag, cnzz_root_s);
  }

  function buryingPointBaidu() {
    let baidu_span = document.createElement('span');
    let scripts = document.getElementsByTagName('script')
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src == `https://hm.baidu.com/h.js?${dxhy_baidu_id}`) {
        nums = 1;
      }
    }
    if (nums == 1) {
      return false;
    }

    baidu_span.style.cssText = 'display:none';
    document.getElementsByTagName('html')[0].appendChild(baidu_span);
    let baidu_s_tag = document.createElement('script');
    baidu_s_tag.type = 'text/javascript';

    baidu_s_tag.charset = 'utf-8';
    baidu_s_tag.src = `https://hm.baidu.com/h.js?${dxhy_baidu_id}`;
    let baidu_root_s = document.getElementsByTagName('script')[0];
    baidu_root_s.parentNode.insertBefore(baidu_s_tag, baidu_root_s);
  }

  /**
   * 按钮埋点方法
   * category  必填  string  表示事件发生在谁身上，如“我的发票banner列表”等。
   * action  必填  string  表示访客跟元素交互的行为动作，如"大象生活banner"等。
   * label  选填  string  用于更详细的描述事件，如具体是哪个视频，哪部小说，示例“点击大象生活banner”。
   * value  选填  int  分值，整型，默认填1
   * nodeid  选填  string  填写事件元素的div元素id。  请填写class id，暂不支持name
   */
  function buryingPointForButton(category, action, label, value, nodeid) {
    initBuryingPoint();

    window._czc = typeof window._czc === 'undefined' ? [] : window._czc
    window._czc.push(['_setAccount', dxhy_cnzz_id]);
    window._czc.push(['_trackEvent', category, action, label, value, nodeid]);


    let _hmt = typeof _hmt === 'undefined' ? [] : _hmt
    _hmt.push(['_trackEvent', category, action, label, value]);
  }

  function initBuryingPoint() {
    if (initPageBurry) {
      burryPointCnzz(); // 友盟埋点
      buryingPointBaidu(); // 百度埋点
      initPageBurry = false;
    }
  }

  // 兼容旧代码
  return buryingPointForButton
}());
